export default __webpack_public_path__ + "static/ecssd-view-metric-d60a260fc1182d1398037fef9b6b8f7a.png";